<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M3 13.5H14.5" stroke="#E5E5E5" stroke-width="1.5" stroke-linecap="round"/>
  <ellipse cx="4.5" cy="8.5" rx="2.5" ry="4" stroke="#E5E5E5" stroke-width="1.3"/>
  <ellipse cx="4.5" cy="8.5" rx="1.2" ry="2" stroke="#E5E5E5" stroke-width="1.1"/>
  <path d="M4.5 4.5H13.5C14.6 4.5 15.5 6.3 15.5 8.5C15.5 10.7 14.6 12.5 13.5 12.5H4.5" stroke="#E5E5E5" stroke-width="1.3"/>
</svg>
